import React, { createContext, useState, useContext } from 'react';

const EventDetailModal = createContext();

export default function EventDetailModalProvider({ children }) {
    const [eventDetailModal, setEventDetailModal] = useState(null);

    return (
        <EventDetailModal.Provider value={{ eventDetailModal, setEventDetailModal }}>
            {children}
        </EventDetailModal.Provider>
    );
}

export function useEventDetailModal() {
    const context = useContext(EventDetailModal);

    if (!context) throw new Error('useEventDetailModal must be used within a EventDetailModalProvider');

    const { eventDetailModal, setEventDetailModal } = context;
    return { eventDetailModal, setEventDetailModal };
}